import { Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { ServiceAndLocation } from '@voice/utils';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgClass, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-client-onboarding-location-service',
  standalone: true,
  imports: [
    DialogModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    NgIf,
    NgClass,
    ButtonDirective,
  ],
  templateUrl: './service-form.component.html',
})
export class ServiceFormComponent implements OnInit {
  record?: ServiceAndLocation;
  serviceFormGroup!: FormGroup;

  serviceTypeValues = [
    { label: 'Hosted Voice Services', value: 'Hosted Voice Services' },
    { label: 'Trunking Services', value: 'Trunking Services' },
  ];

  constructor(
    private readonly dialogRef: DynamicDialogRef,
    public readonly dialogConfig: DynamicDialogConfig
  ) {}

  get isNew(): boolean {
    return !this.record?.companyName;
  }

  ngOnInit(): void {
    this.record = this.dialogConfig.data.record;
    this.serviceFormGroup = new FormGroup({
      ...(this.isNew
        ? {
            companyName: new FormControl('', [
              Validators.required,
              Validators.minLength(1),
            ]),
          }
        : {}),
      provider: new FormControl(this.record?.provider || 'UDT', [
        Validators.required,
        Validators.minLength(1),
      ]),
      serviceType: new FormControl(
        this.record?.serviceType || this.serviceTypeValues[0].value,
        [Validators.required, Validators.minLength(1)]
      ),
    });
  }

  isControlInvalid(controlName: string): boolean | undefined {
    return (
      this.serviceFormGroup.get(controlName)?.invalid &&
      this.serviceFormGroup.get(controlName)?.touched
    );
  }

  save(): void {
    if (this.serviceFormGroup.valid) {
      const result: ServiceAndLocation = {
        ...this.record,
        companyName: this.isNew
          ? this.serviceFormGroup.get('companyName')?.value
          : this.record?.companyName || '',
        provider: this.serviceFormGroup.get('provider')?.value,
        serviceType: this.serviceFormGroup.get('serviceType')?.value,
      };
      this.dialogRef.close(result);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  onServiceTypeChange(event: DropdownChangeEvent) {
    this.serviceFormGroup.get('serviceType')?.setValue(event.value);
  }
}
